import LogoutComponent from './LogoutComponent';

export default LogoutComponent;
